/*
  Tokyo Romance Club — NEW ARRIVALS scroll reveal.
  Each heading/card/button is observed independently via its own
  IntersectionObserver entry, so mobile only reveals cards as they
  individually scroll into view (not a single whole-section cascade).
  Cards that become visible together (e.g. one PC row) still stagger by
  ~100ms relative to each other. Once revealed, an element is unobserved
  and never re-hidden. Never runs inside the theme editor.
*/
(function () {
  if (window.__trcNewArrivalsMotionInit) return;
  window.__trcNewArrivalsMotionInit = true;

  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  if (designMode) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var REVEAL_CLASS = 'trc-na-in';
  var STAGGER_MS = 100;

  function reveal(el) {
    el.classList.add(REVEAL_CLASS);
  }

  function collectTargets(section) {
    var targets = [];
    var heading = section.querySelector('[class*="__heading_text"]');
    if (heading) targets.push(heading);
    section.querySelectorAll('.product-card').forEach(function (card) {
      targets.push(card);
    });
    var viewAll = section.querySelector('[class*="__view_all"]');
    if (viewAll) targets.push(viewAll);
    return targets;
  }

  function init() {
    var section = document.querySelector('[id$="__trc_new_arrivals"]');
    if (!section) return;

    document.documentElement.classList.add('trc-js');

    var targets = collectTargets(section);
    if (targets.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .forEach(function (entry, i) {
            io.unobserve(entry.target);
            window.setTimeout(function () {
              reveal(entry.target);
            }, i * STAGGER_MS);
          });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    targets.forEach(function (target) {
      io.observe(target);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
